angular.module('cimerFrontEndApp').directive('surveyQuestion', ['$uibModal', 'SurveyService', function ($uibModal, SurveyService) {
    'use strict';
    return {
        restrict: 'EA',
        templateUrl: '/Content/Templates/surveyQuestionTemplate.html',
        scope: {
            question: '=question',
            index: '=index',
            deleteQuestion: '&',
            editQuestionDisplayLogic: '&',
            sectionRoleId: '=sectionRoleId',
            directorId: '=directorId',
            deleteQuestionDisplayLogic: '&',
            updateChildren: '&'
        },
        link: function (scope) {
            // If we're editing a base survey, we won't have a director id, so determine base/custom survey context from that variable
            scope.contextIsCustomSurvey = scope.directorId !== null;
            scope.roleEnum = SurveyService.QuestionRole;
            scope.questionIsParent = false;
            scope.questionIsChild = true;
            scope.logicTooltipText = "";
            var watchers = [];
            // Set the initial properties and watchers
            updateWatchers();
            updateProperties();

            // Update the scope properties and watchers if the question is updated (for example, via rearrangement)
            scope.$watch(function () { return scope.question; }, function () {
                updateWatchers();
                updateProperties();
            });
            scope.$watch(function () { return scope.question.details; }, function () {
                updateWatchers();
                updateProperties();
            });
            

            function updateWatchers() {
                // Deregister all the previous type-specific watchers to start from a clean slate
                while (watchers.length) {
                    // Call the deregistration function of each watcher we get off the list
                    watchers.pop()();
                }
                // Any watchers that are set up based on the question type need to be updated on sort or they will be stuck with the previous question type's watchers
                if (scope.question.typeID === 0) {
                    var matrixQuestionBranchWatcher = scope.$watch(function () { return scope.question.details.Questions[0].QuestionBranches; }, function () {
                        updateProperties();
                    });
                    watchers.push(matrixQuestionBranchWatcher);
                }
                else {
                    var nonMatrixQuestionBranchWatcher = scope.$watch(function () { return scope.question.details.QuestionBranches; }, function () {
                        updateProperties();
                    });
                    watchers.push(nonMatrixQuestionBranchWatcher);
                    if (scope.question.typeID === 1 || scope.question.typeID === 4) { // if it's a potential parent, watch the scale answers for branch changes as well
                        var scaleAnswerQuestionBranchWatcher = scope.$watchCollection(function () { return scope.question.details.QuestionScale.map(sa => sa.QuestionBranch); }, function () {
                            updateProperties();
                        });
                        watchers.push(scaleAnswerQuestionBranchWatcher);
                    }
                }
            }

            function updateProperties() {
                // Everything is always editable for a base survey, otherwise only allow editing in custom sections on a custom survey
                scope.isEditable = !scope.contextIsCustomSurvey || (scope.sectionRoleId === scope.roleEnum.Custom);
                scope.logicTooltipText = "";
                scope.questionIsParent = false;
                scope.questionIsChild = false;
                if (scope.index === 0) {
                    scope.logicTooltipText = "Logic cannot be added to the first question in a section";
                }
                // Determine if this question is a parent question
                if (scope.question.typeID !== 3 && scope.question.typeID !== 0) { // filter out matrix and text questions
                    for (var i = 0; i < scope.question.details.QuestionScale.length; i++) {
                        if (scope.question.details.QuestionScale[i].QuestionBranch.getID() !== null) {
                            scope.questionIsParent = true;
                            if (scope.index !== 0) { // Don't overwrite the tooltip text if it's also the first question in a section
                                scope.logicTooltipText = "Logic cannot be added to this question because it is used to determine the display of another question";
                            }
                            break;
                        }
                    }
                }

                // Determine if this question is a child question
                if (scope.question.typeID === 0) { // matrix question
                    scope.questionIsChild = scope.question.details.Questions[0].QuestionBranches.length > 0;
                }
                else {
                    scope.questionIsChild = scope.question.details.QuestionBranches.length > 0;
                }
            }


            // Edit the question
            scope.editQuestion = function () {
                // Shouldn't be editing a non-editable question
                if (!scope.isEditable) { return; }

                var editQuestionModalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: '/Content/Templates/survey/editQuestionModal.html',
                    controller: 'EditQuestionModalCtrl',
                    size: 'lg',
                    backdrop: 'static',
                    resolve: {
                        question: function () {
                            return scope.question;
                        },
                        directorID: function () {
                            return scope.directorId;
                        }
                    }
                });

                editQuestionModalInstance.result.then(function (questionObj) {
                    // modal closed, save new object
                    if (scope.questionIsParent) {
                        // Check if any of the relevant information about the parent has changed (parent text or scale answer text)
                        var updateChildren = false;
                        if (questionObj.details.Text !== scope.question.details.Text) { // don't have to worry about matrix questions because matrices can't be parent questions
                            updateChildren = true;
                        }
                        else { // skip checking the scale answers if we know we're already updating based on the question text changing
                            for (var i = 0; i < questionObj.details.QuestionScale.length; i++) {
                                // Check if a scale answer used in display logic has had its text updated
                                var scale = questionObj.details.QuestionScale[i];
                                if (scale.QuestionBranch.getID() !== null && scale.AnswerText !== scope.question.details.QuestionScale[i].AnswerText) {
                                    updateChildren = true;
                                    break;
                                }
                            }
                        }
                    }
                    scope.question = angular.copy(questionObj);
                    // Pass in the new object to the update children call because angular.copy can be slow enough where the info is not copied over before the children get updated
                    if (updateChildren) {
                        scope.updateChildren({ questionIndex: scope.index, parentObj: questionObj });
                    }
                    
                }, function () {
                    // modal cancelled - do nothing
                });

            }; // end editQuestion

            // Edit the question's display logic
            scope.editDisplayLogic = function () {
                // Make sure we're not trying to add logic to a non-editable question or to a parent question or to the first question 
                if (!scope.isEditable || scope.questionIsParent || scope.index === 0) { return false; }
                scope.editQuestionDisplayLogic({ questionIndex: scope.index });
            };

            scope.deleteDisplayLogic = function () {
                // Make sure we're not deleting logic off of a non-editable question
                if (!scope.isEditable) { return false; }
                scope.deleteQuestionDisplayLogic({ questionIndex: scope.index });
            };

            scope.delete = function () {
                // Make sure we're not trying to delete a non-editable or parent question
                if (!scope.isEditable || scope.questionIsParent) { return false; }
                // If this is a child question, remove its display logic first so its parents can be updated
                if (scope.questionIsChild) {
                    scope.deleteQuestionDisplayLogic({ questionIndex: scope.index });
                }
                // Then delete itself from the survey
                scope.deleteQuestion({ questionIndex: scope.index });
            };
        }
    };
}]);